"use client";

import Link from "next/link";
import React, { useEffect, useState } from "react";
// import Link from 'next/link';
import { usePathname } from "next/navigation";
import { padding } from "@/services/commonFunction";

interface SubCategoryHeaderProps {
  data: {
    subCategories: {
      name: string;
      slug: string;
    }[];
    category: {
      name: string;
      slug: string;
      parent?: {
        slug: string;
        name: string;
      };
    };
  };
}

const convertSlugToCategory = (slug: string) => {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const SubCategoryHeader: React.FC<SubCategoryHeaderProps> = ({
  data,
}) => {
  const pathname = usePathname();
  const [categoryName, setCategoryName] = useState<string | null>(null);
  // const [parentSlug, setParentSlug] = useState<string | null>(null);
  // const links = navigationLinks[category as keyof typeof navigationLinks] || [];

  useEffect(() => {
    const categoryName = pathname?.split("/");
    // console.log("categoryName=>0", categoryName);
    if (categoryName?.length==4) {
      setCategoryName(categoryName[2]);
    }
    // if (categoryName) {
    //   const categoryIndex = categoryName.indexOf('category');
    //   if (categoryIndex !== -1 && categoryName.length>categoryIndex+1) {
    //     setParentSlug(categoryName[categoryIndex + 1]);
    //   }
    // }
  }, [pathname]);

  return (
    <header className="w-full bg-white">
      <div className={`max-w-7xl ${padding.py} px-4 lg:px-8 xl:px-0 mx-auto flex flex-col lg:flex-row md:justify-start md:gap-x-8 lg:items-end`}>
        {/* Category Title */}
        <div className="mb-3 lg:mb-0 text-inkBlack">
          <div className="flex items-start gap-x-4 flex-col">
            <p className="text-lg md:text-sm font-bold capitalize tracking-widest">
              {data?.category?.parent?.slug ? (
                <Link href={`/category/${data.category.parent.slug}`} className="text-orange-500" prefetch={false}>
                  {/* {categoryName ? convertSlugToCategory(categoryName) : ""} */}
                  {data.category.parent.name}
                </Link>
              ) : (
                <span className="text-orange-500">
                  {categoryName ? convertSlugToCategory(categoryName) : ""}
                </span>
              )}
            </p>
            {data?.subCategories &&
              data?.subCategories?.length > 0 &&
              pathname?.includes(`/category/${data?.category?.slug}/`) && (
                <p className="text-lg md:text-lg font-medium capitalize tracking-widest">
                  {categoryName ? convertSlugToCategory(categoryName) : ""}{" "}
                  {data?.category?.name}
                </p>
              )}
            <h1 className="text-[32px] md:text-6xl font-medium capitalize lg:whitespace-nowrap whitespace-normal text-ellipsis">
              {data?.category?.name}
              <span className="text-orange">.</span>
            </h1>
          </div>
        </div>

        {/* Navigation */}
        {/* {JSON.stringify(data.subCategories)} */}
        
        <nav className="">
        <div className="flex flex-wrap gap-y-4 gap-x-6 md:gap-x-12 items-center snap-x snap-mandatory scroll-smooth touch-pan-x">
          {data?.subCategories?.map((link, index) => (
            <Link
              key={`link-${index}`}
              href={`/category/${data?.category?.slug}/${link?.slug}`}
              className={`text-sm md:text-sm font-normal transition-colors uppercase hover:text-orange-500 whitespace-nowrap
                ${
                  pathname === `/${data?.category?.slug}/${link?.slug}`
                    ? "text-orange-500"
                    : "text-inkBlack"
                }`}
                prefetch={false}
            >
              {link?.name}
            </Link>
          ))}
        </div>
        </nav>
      </div>
    </header>
  );
};
